import axios from 'axios';

const csrfToken = () => {
  return document.getElementsByName('csrf-token').item(0).content;
};

axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken();

/**********************************************************
 * 共通エラーハンドリング
 **********************************************************/
axios.interceptors.response.use(
  (response) => {
    // 成功
    return response;
  },
  (error) => {
    // 例外
    switch (error.response?.status) {
      case 401: // 未認証ユーザー
        if (location.pathname.startsWith('/u')) {
          location.href = '/u';
        }
        break;

      default:
        // その他
        return Promise.reject(error);
    }
  },
);

export { csrfToken, axios };
